import './App.css';
import plan from './media/3bhk/ssfh3bhkplan.png';
import wa from './WhatsAppButtonGreenSmall.svg';
import pdf from './media/3bhk/SSFH_3BHK_Photos_9448008076.pdf'

function App() {
  const body = encodeURIComponent(`Hi, I am interested in 3BHK Flat C107 in SSFH`);

  return (
      <div className="root">
        <h3>1385 Sq Ft, 3Bed, 3Bath Flat with Large Living and Dining Room, Attached Balcony and Utility, Gym,
Party Hall, Badminton Court, Swimming Pool and Play Area for Kids, 24x7 Security, CCTV, 2 Lifts,
Covered Car Parking, Rain Water Harvesting in SS Felicity Homes, Borewell Rd, Whitefield</h3>
        <div className="embeds">

          <iframe title="SS Felicity Homes location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.036433688571!2d77.73793177507643!3d12.96952048734565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae12016afee8f3%3A0x885c10c9324ce2b1!2sSS%20Felicity%20Homes!5e0!3m2!1sen!2sus!4v1741497761187!5m2!1sen!2sus"
              frameBorder={0} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            <img src={plan} alt="3BHK floor plan" />
            <h2>This is 2 year old video. Walls, doors and grills are repainted completely. Visit the flat to see the new look.</h2>
          <iframe src="https://www.youtube.com/embed/PsthahQLfNk" title="3BHK flat tour" frameBorder="0"
                  allow="accelerometer;clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen></iframe>


        </div>

        <div className="text">

            <a className="download" href={pdf} download><button>Download Flat Photos</button></a><br />
          Deposit: Rs. 200000, Monthly Rent: Rs. 46000, Maintenance Rs 3384, Water and Electricity Charges by Meter<br />
          Contact Security to visit the flat.
        </div>

        <a aria-label="Chat on WhatsApp" href={`https://wa.me/919448008076?text=${body}`}>
        <img alt="Chat on WhatsApp" src={wa}/>
        </a>
      </div>
  );

/*
  return (
    <div className="App">
      <header className="App-header">

        <p>Thanks for showing interest in visiting the 3BHK flat in SS Felicity Home.</p>
        <iframe src="https://www.youtube.com/embed/PsthahQLfNk"  title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>
        <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3890.7680056255624!2d77.7379318!3d12.9695205!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae12016afee8f3%3A0x885c10c9324ce2b1!2sSS%20Felicity%20Homes!5e0!3m2!1sen!2sin!4v1710000000000"
            allowFullScreen=""
            loading="lazy"
            frameborder={0}
            referrerPolicy="no-referrer-when-downgrade">
        </iframe>

        <p>Monthly Rent: Rs. 40000, Maintenance: Rs. 3500</p>
        <p>Contact Security to visit the flat.</p>
        <a aria-label="Chat on WhatsApp" href={`https://wa.me/919448008076?text=${body}`}>
        <img alt="Chat on WhatsApp" src={wa}/>
        </a>
      </header>
    </div>
  );
*/
}

export default App;
